import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cheque-bounce-matters',
  templateUrl: './cheque-bounce-matters.component.html',
  styleUrls: ['./cheque-bounce-matters.component.css']
})
export class ChequeBounceMattersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
